import React from 'react';
import { Link } from 'react-router-dom';
import './App.css';

function Home() {
  return (
    <div className="app">
      {/* Navigation */}
      <nav className="navbar">
        <div className="nav-container">
          <Link to="/" className="logo">
            <img src="/School logo.png" alt="AJWS Logo" className="logo-image" />
            <div className="logo-text">
              <span className="logo-title">AJWS</span>
              <span className="logo-subtitle">Anil Jindal World School</span>
            </div>
          </Link>
          <div className="nav-links">
            <a href="#features">Features</a>
            <a href="#users">Who Uses It</a>
            <a href="#get-started" className="cta-button">Get Started</a>
          </div>
        </div>
      </nav>

      {/* Hero Section */}
      <section className="hero">
        <div className="hero-container">
          <h1 className="hero-title">
              Stay Connected with Your Child's Education.<br />
            Every Day.
          </h1>
          <p className="hero-subtitle">
            See what your child is learning, track their progress, and communicate 
            with teachers—all in one place for parents, teachers, and school staff.
          </p>
          <div className="hero-buttons">
            <a href="#get-started" className="btn-primary">Get Started</a>
            <a href="#features" className="btn-secondary">Learn More</a>
          </div>
        </div>
      </section>

      {/* Features Overview */}
      <section id="features" className="features">
        <div className="container">
          <h2 className="section-title">Everything Your School Needs</h2>
          <p className="section-subtitle">
            Tools to help students learn, parents stay informed, and teachers teach effectively.
          </p>
          <div className="features-grid">
            <div className="feature-card">
              <div className="feature-icon">📝</div>
              <h3>Homework</h3>
              <p>See what homework your child has, when it's due, and help them stay on track.</p>
            </div>
            <div className="feature-card">
              <div className="feature-icon">📊</div>
              <h3>Student Progress</h3>
              <p>See how your child is doing in each subject and celebrate their achievements.</p>
            </div>
            <div className="feature-card">
              <div className="feature-icon">💬</div>
              <h3>Talk with Teachers</h3>
              <p>Message teachers directly to ask questions and stay updated on your child.</p>
            </div>
            <div className="feature-card">
              <div className="feature-icon">📅</div>
              <h3>Leave Requests</h3>
              <p>Let the school know when your child will be absent in advance.</p>
            </div>
            <div className="feature-card">
              <div className="feature-icon">📢</div>
              <h3>School News</h3>
              <p>Get important updates about school events, holidays, and news right away.</p>
            </div>
            <div className="feature-card">
              <div className="feature-icon">📆</div>
              <h3>School Calendar</h3>
              <p>Know about sports days, parent meetings, holidays, and other school events.</p>
            </div>
            <div className="feature-card">
              <div className="feature-icon">✅</div>
              <h3>Attendance</h3>
              <p>See if your child is present in class each day and stay informed.</p>
            </div>
            <div className="feature-card">
              <div className="feature-icon">⏰</div>
              <h3>Class Schedule</h3>
              <p>Check your child's daily class schedule and know what they're learning when.</p>
            </div>
            <div className="feature-card">
              <div className="feature-icon">🌍</div>
              <h3>Multiple Languages</h3>
              <p>Use the app in your preferred language so everyone can stay connected.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Users Section */}
      <section id="users" className="users-section">
        <div className="container">
          <div className="users-header">
            <h2 className="section-title">For Everyone in Our School Community</h2>
            <p className="section-subtitle">
              Whether you're a parent, teacher, administrator, or principal—we're here to help you support students and keep our school connected.
            </p>
          </div>
          
          <div className="users-grid">
            <div className="user-card">
              <div className="user-icon-wrapper">
                <div className="user-icon parent-icon">
                  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M17 21V19C17 17.9391 16.5786 16.9217 15.8284 16.1716C15.0783 15.4214 14.0609 15 13 15H5C3.93913 15 2.92172 15.4214 2.17157 16.1716C1.42143 16.9217 1 17.9391 1 19V21" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M9 11C11.2091 11 13 9.20914 13 7C13 4.79086 11.2091 3 9 3C6.79086 3 5 4.79086 5 7C5 9.20914 6.79086 11 9 11Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M23 21V19C22.9993 18.1137 22.7044 17.2528 22.1614 16.5523C21.6184 15.8519 20.8581 15.3516 20 15.13" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M16 3.13C16.8604 3.35031 17.623 3.85071 18.1676 4.55232C18.7122 5.25392 19.0078 6.11683 19.0078 7.005C19.0078 7.89318 18.7122 8.75608 18.1676 9.45769C17.623 10.1593 16.8604 10.6597 16 10.88" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </div>
              </div>
              <h3 className="user-card-title">Parents</h3>
              <p className="user-card-description">
                See what your child is learning each day, how they're progressing, and stay in touch with their teachers about their education.
              </p>
              <ul className="user-features">
                <li>Check homework and assignments</li>
                <li>See how your child is doing in school</li>
                <li>Message teachers when you need to</li>
                <li>Submit leave requests and check attendance</li>
                <li>Manage multiple children from one account</li>
              </ul>
            </div>

            <div className="user-card">
              <div className="user-icon-wrapper">
                <div className="user-icon teacher-icon">
                  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M12 14L9 11L12 8L15 11L12 14Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M12 2L2 7L12 12L22 7L12 2Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M2 17L12 22L22 17" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M2 12L12 17L22 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </div>
              </div>
              <h3 className="user-card-title">Teachers</h3>
              <p className="user-card-description">
                Share homework, track how students are doing, and talk with parents about their children's learning and progress.
              </p>
              <ul className="user-features">
                <li>Manage your classes and students</li>
                <li>Share homework and classwork</li>
                <li>Review and approve leave requests</li>
                <li>Send announcements and messages</li>
                <li>Update your class schedule</li>
              </ul>
            </div>

            <div className="user-card">
              <div className="user-icon-wrapper">
                <div className="user-icon admin-icon">
                  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M12 15C15.866 15 19 11.866 19 8C19 4.13401 15.866 1 12 1C8.13401 1 5 4.13401 5 8C5 11.866 8.13401 15 12 15Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M8.21 13.89L7 23L12 20L17 23L15.79 13.88" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </div>
              </div>
              <h3 className="user-card-title">Administrators</h3>
              <p className="user-card-description">
                Keep an eye on how the school is running, see reports on student progress, and make sure everything runs smoothly.
              </p>
              <ul className="user-features">
                <li>View how the whole school is doing</li>
                <li>Generate reports on student progress</li>
                <li>Manage who has access to what</li>
                <li>Update school settings and information</li>
                <li>Oversee school operations</li>
              </ul>
            </div>

            <div className="user-card">
              <div className="user-icon-wrapper">
                <div className="user-icon principal-icon">
                  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M19 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V5C3 4.46957 3.21071 3.96086 3.58579 3.58579C3.96086 3.21071 4.46957 3 5 3H19C19.5304 3 20.0391 3.21071 20.4142 3.58579C20.7893 3.96086 21 4.46957 21 5V19C21 19.5304 20.7893 20.0391 20.4142 20.4142C20.0391 20.7893 19.5304 21 19 21Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M9 9L15 9" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M9 15L15 15" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M9 12L15 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </div>
              </div>
              <h3 className="user-card-title">Principals</h3>
              <p className="user-card-description">
                See how the school is performing overall, make informed decisions, and ensure students get the best education possible.
              </p>
              <ul className="user-features">
                <li>Overview of school-wide performance</li>
                <li>Monitor student and teacher progress</li>
                <li>Plan and manage school events</li>
                <li>Coordinate communication across the school</li>
                <li>Get insights on how the school is doing</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* Technical Features */}
      <section className="tech-features">
        <div className="container">
          <h2 className="section-title">Available Everywhere</h2>
          <p className="section-subtitle">
            Access your school information on your phone, tablet, or computer whenever you need it.
          </p>
          <div className="tech-grid">
            <div className="tech-item">
              <div className="tech-icon">📱</div>
              <h3>All Devices</h3>
              <p>Use it on your phone, tablet, or computer</p>
            </div>
            <div className="tech-item">
              <div className="tech-icon">🌐</div>
              <h3>Your Language</h3>
              <p>Switch to the language you're most comfortable with</p>
            </div>
            <div className="tech-item">
              <div className="tech-icon">🌙</div>
              <h3>Light & Dark Mode</h3>
              <p>Pick the view that's easiest on your eyes</p>
            </div>
            <div className="tech-item">
              <div className="tech-icon">🔒</div>
              <h3>Safe & Secure</h3>
              <p>Your information and your child's information stays private</p>
            </div>
            <div className="tech-item">
              <div className="tech-icon">⚡</div>
              <h3>Instant Updates</h3>
              <p>Get notified right away about important news and updates</p>
            </div>
            <div className="tech-item">
              <div className="tech-icon">📴</div>
              <h3>Works Offline</h3>
              <p>View some information even when you don't have internet</p>
            </div>
          </div>
        </div>
      </section>

      {/* Call to Action */}
      <section id="get-started" className="cta-section">
        <div className="container">
          <h2 className="cta-title">Ready to Get Started?</h2>
          <p className="cta-subtitle">
            Join our school community and stay connected with your child's education every day.
          </p>
          <div className="cta-buttons">
            <a href="#contact" className="btn-primary large">Contact Us</a>
            <a href="#learn-more" className="btn-secondary large">Learn More</a>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="footer">
        <div className="container">
          <div className="footer-content">
            <div className="footer-logo">
              <img src="/School logo.png" alt="AJWS Logo" className="logo-image" />
              <div className="logo-text">
                <span className="logo-title">AJWS</span>
                <span className="logo-subtitle">Anil Jindal World School</span>
              </div>
            </div>
            <div className="footer-links">
              <div className="footer-column">
                <h4>Product</h4>
                <a href="#features">Features</a>
                <a href="#users">Who Uses It</a>
                <a href="#get-started">Get Started</a>
              </div>
              <div className="footer-column">
                <h4>Resources</h4>
                <Link to="/privacy-policy">Privacy Policy</Link>
                <Link to="/support">Support</Link>
              </div>
            </div>
          </div>
          <div className="footer-bottom">
            <p>&copy; {new Date().getFullYear()} Anil Jindal World School. All rights reserved.</p>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default Home;

